class Request {
    data = {};

    constructor() {
        this.data = Object.fromEntries(new URLSearchParams(location.search));
    }

    fill(data) {
        for(let key in data) {
            this.data[key] = data[key];
        }
        return this;
    }

    setByKeyValue(key, value) {
        this.data[key] = value;
        return this;
    }


    reload() {
        $.ajax({
            url: window.location.pathname,
            data: this.data,
            success: this.onSuccess.bind(this),
            error: this.onError.bind(this)
        });
        return this;
    }

    onSuccess(response) {
        let query = (new URLSearchParams(this.data)).toString();
        window.history.pushState(this.data, '', window.location.pathname + '?' + query);
        this.handleResponse(response);
    }

    onError(response) {

    }

    handleResponse(response) {

    }
}

export default Request;
